// DS6.10 for deviations
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DaDreamupLogo from '@wix/da-ds/pkg/DaDreamupLogo';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationCoreBadgeList from '../coreBadge/CoreBadgeList/presets/DeviationCoreBadgeList';
import FaveStat from './FaveStat';
import CommentStat from './CommentStat';
import ViewStat from './ViewStat';
import SubscriberStat from './SubscriberStat';
import PremiumDownloadStat from './PremiumDownloadStat';
import { DeviationTypes } from '../types/deviation';
import { getDeviationType } from '../DeviationViews/_helpers';
import { getCurrentUser, getCurrentUserHasCore } from '../publicSession/selectors';
import DAProtectIconWithTooltip from '../DAProtectIconWithTooltip';
import NoAIWithTooltip from '../NoAIWithTooltip';
import PrivateCollectionStat from './PrivateCollectionsStat/PrivateCollectionsStat';
import s from './Stats.scss';
const Stats = ({ deviation, onlyNumbers: showOnlyNumbers, withFavouriteControl = true, withCommentControl = true, withViewCount = true, withPrivateCollectionsCount = false, withSubscriberCount = false, withPremiumDownloadCount = false, withBadges = true, withUserList = true, withDaProtectIndicator = true, withNoAiIndicator = true, withDreamupLabel = true, className, statClassName, badgelistClassName, onCommentClick })=>{
    var _deviation_author;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const isDreamupDpAlterationsFlagEnabled = useFlag('dreamup_dp_alterations');
    const deviationType = getDeviationType(deviation);
    const onlyNumbers = !!(showOnlyNumbers || isMobile);
    const currentUser = useSelector(getCurrentUser);
    const hasCore = useSelector(getCurrentUserHasCore);
    const isStashItem = (deviation === null || deviation === void 0 ? void 0 : deviation.isPublished) === false;
    const isCurrentUserDeviationOwner = !!currentUser && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) === ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.userId);
    const daProtectLevel = deviation.extended && deviation.extended.isDaProtected ? hasCore ? 'active' : 'temporary' : 'inactive';
    const showDAProtectIndicator = withDaProtectIndicator && deviationType === DeviationTypes.IMAGE && isCurrentUserDeviationOwner && !deviation.isDreamsofart;
    return /*#__PURE__*/ React.createElement(Flex, {
        className: className,
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, withFavouriteControl && !isStashItem && /*#__PURE__*/ React.createElement(FaveStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers,
        withUserList: !isMobile && withUserList
    }), withCommentControl && /*#__PURE__*/ React.createElement(CommentStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers,
        withUserList: !isMobile && withUserList,
        onClick: onCommentClick
    }), withViewCount && /*#__PURE__*/ React.createElement(ViewStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers
    }), withPrivateCollectionsCount && /*#__PURE__*/ React.createElement(PrivateCollectionStat, {
        deviation: deviation,
        onlyNumbers: onlyNumbers
    }), withSubscriberCount && /*#__PURE__*/ React.createElement(SubscriberStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers
    }), withPremiumDownloadCount && /*#__PURE__*/ React.createElement(PremiumDownloadStat, {
        className: statClassName,
        deviation: deviation,
        onlyNumbers: onlyNumbers
    }), showDAProtectIndicator && !isStashItem && /*#__PURE__*/ React.createElement(DAProtectIconWithTooltip, {
        withLabel: true,
        variant: daProtectLevel,
        className: s['da-protect']
    }), isCurrentUserDeviationOwner && deviation.isAiUseDisallowed && withNoAiIndicator && /*#__PURE__*/ React.createElement(NoAIWithTooltip, {
        className: c(s['no-ai'], !showDAProtectIndicator && s['no-ai-with-border'])
    }), deviation.isDreamsofart && withDreamupLabel && !isDreamupDpAlterationsFlagEnabled && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['dreamup-tag'],
        href: Url.dreamupLink()
    }, /*#__PURE__*/ React.createElement(DaDreamupLogo, {
        className: s['dreamup-icon']
    }), t('deviation.stats.dreamup'))), withBadges && /*#__PURE__*/ React.createElement(DeviationCoreBadgeList, {
        deviation: deviation,
        className: c(badgelistClassName, s['badges'])
    }));
};
export default Stats;
